const isProduction = process.env.NODE_ENV === 'production';

export const FEEDESK_API_BASE_URL = isProduction
  ? 'https://www.feedeskapi.bsparksoftwaretechnologies.com/api'  // ← replace with your real Feedesk API URL
  : 'http://localhost:5000/api';  // ← replace with your Feedesk local port

export const FEEDESK_API = {
  BASE: FEEDESK_API_BASE_URL,
  ORG_REGISTER: `${FEEDESK_API_BASE_URL}/auth/register`,
  LOGIN: `${FEEDESK_API_BASE_URL}/auth/login`,
};